import * as React from 'react'
import {
  List,
  TextField,
  FunctionField,
  DatagridConfigurable,
  TopToolbar,
  SelectColumnsButton,
  TextInput,
  Link,
  FilterButton,
  ReferenceInput,
  SelectInput,
  ShowButton,
} from 'react-admin'
import { ProviderField, ToolTip } from '../fields/kitFields'
import RequestedField from '../fields/notificationFields'

const NotificationList = (props) => {
  const NotificationFilters = [
    <TextInput label="Kit / Request ID" source="q" alwaysOn />,
    <ReferenceInput source="providerId" reference="providers" alwaysOn>
      <SelectInput optionText={'displayName'} />
    </ReferenceInput>,
    <SelectInput
      label="Status"
      source="status"
      alwaysOn
      emptyText={'All'}
      choices={[
        { id: 'requested', name: 'Requested' },
        { id: 'inprogress', name: 'In Progress' },
        { id: 'complete', name: 'Complete' },
        { id: 'failure', name: 'Failure' },
        { id: 'error', name: 'Error' },
      ]}
    />,
  ]
  return (
    <List
      {...props}
      actions={
        <TopToolbar>
          <FilterButton />
          <SelectColumnsButton />
        </TopToolbar>
      }
      filters={NotificationFilters}
      filter={{ _order: 'DESC' }}
    >
      <DatagridConfigurable bulkActionButtons={<></>}>
        <FunctionField
          style={{ width: 'fit-content' }}
          label="Reference"
          render={(record) => {
            if (record.kitId) {
              return <Link to={`/kits/${record.kitId}/show`}>{record.kitId}</Link>
            }
            if (record.requestId) {
              return <Link to={`/kit-requests/${record.requestId}/show`}>{record.requestId}</Link>
            }
            return null
          }}
        />
        <RequestedField label="Requested" />
        <TextField label="Patient Name" source="patientName" />
        <TextField label="Event Type" source="eventType" />
        <TextField label="Type" source="type" />
        <TextField label="Method" source="method" />
        <TextField label="Status" source="status" />
        <FunctionField
          label="Created"
          render={(record) => {
            if (!record.createdAt) return null
            const d = new Date(record.createdAt)
            const date = `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}/${d.getFullYear()}`
            const time = `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`
            return `${date} ${time}`
          }}
        />
        <ProviderField label="Provider Info" />
        <TextField label="Fax Number" source="faxNumber" />
        <ShowButton label="Show" />
      </DatagridConfigurable>
    </List>
  )
}

export default NotificationList
